export const addItemToCart = (
  {
    prdId: newPrdId,
    prdName: newPrdName,
    optId: newOptId,
    optLabel: newOptLabel,
    quantity: newQuantity
  }
) => {
  const items = JSON.parse(localStorage.getItem("InCartItems")) ?? [];
  const item = items.find(({prdId, optId}) => prdId === newPrdId && optId === newOptId);

  if (item) {
    // There is an existing item added
    item.quantity += newQuantity;
    item.createdAt = Date.now();

    localStorage.setItem("InCartItems", JSON.stringify(items));

    return 0;
  }
  // There is a new item
  items.push({
    prdId: newPrdId,
    prdName: newPrdName,
    optId: newOptId,
    optLabel: newOptLabel,
    quantity: newQuantity,
    createdAt: Date.now(),
    isCheckout: false,
  });

  localStorage.setItem("InCartItems", JSON.stringify(items));

  return 1;
};

export const getCheckoutItems = () => {
  const inCartItems = JSON.parse(localStorage.getItem("InCartItems"));

  // If cart data is not found then return 0
  if (!inCartItems || inCartItems.length === 0) return [];

  return inCartItems.filter(item => item.isCheckout)
    .map(item => ({
      productId: item.prdId,
      optionId: item.optId,
      quantity: item.quantity,
    }));
};

export const containInCartItems = (checkoutItems) => {
  const inCartItems = JSON.parse(localStorage.getItem("InCartItems"));

  // If cart data is not found then return 0
  if (!inCartItems || inCartItems.length === 0) return false;

  const inCartItemMap = new Map(
    inCartItems.map(item => [`${item.prdId}-${item.optId}`, item])
  );

  // If all item contain in cart then return true, otherwise false
  return checkoutItems.every(({prdId, optId}) => inCartItemMap.has(`${prdId}-${optId}`));
};

export const deleteItemInCheckout = (checkoutItems) => {
  const inCartItems = JSON.parse(localStorage.getItem("InCartItems"));

  const checkoutItemMap = new Map(
    checkoutItems.map(item => [`${item.prdId}-${item.optId}`, item])
  );

  const entity = inCartItems.filter(item => !checkoutItemMap.has(`${item.prdId}-${item.optId}`));

  localStorage.setItem("InCartItems", JSON.stringify(entity));
};

export const countInCartItems = () => {
  const inCartItems = JSON.parse(localStorage.getItem("InCartItems"));
  return inCartItems?.length ?? 0;
};

export const getAllInCartItems = () => {
  const inCartItems = JSON.parse(localStorage.getItem("InCartItems"));
  if (!inCartItems) return [];
  return inCartItems.sort((item1, item2) => item1.createdAt - item2.createdAt)
    .map(inCartItem => ({
      prdId: inCartItem.prdId,
      prdName: inCartItem.prdName,
      optId: inCartItem.optId,
      optLabel: inCartItem.optLabel,
      quantity: inCartItem.quantity,
      isCheckout: inCartItem.isCheckout,
  }));
};

export const updateInCartItemQuantity = ({ prdId, optId, quantity }) => {
  const inCartItems = JSON.parse(localStorage.getItem("InCartItems"));

  // If cart data is not found then return 0
  if (!inCartItems || inCartItems.length === 0) return 0;

  const item = inCartItems.find(item => item.prdId === prdId && item.optId === optId);

  // If item is not found then return 0
  if (!item) return 0;

  item.quantity = quantity;
  localStorage.setItem("InCartItems", JSON.stringify(inCartItems));

  return 1;
};

export const updateInCartItemIsCheckout = ({ prdId, optId, isCheckout }) => {
  const inCartItems = JSON.parse(localStorage.getItem("InCartItems"));

  // If cart data is not found then return 0
  if (!inCartItems || inCartItems.length === 0) return 0;

  const item = inCartItems.find(item => item.prdId === prdId && item.optId === optId);

  // If item is not found then return 0
  if (!item) return 0;

  item.isCheckout = isCheckout;
  localStorage.setItem("InCartItems", JSON.stringify(inCartItems));

  return 1;
};

export const batchUpdateInCartItemIsCheckout = ({ items, isSelectedAll }) => {
  const inCartItems = JSON.parse(localStorage.getItem("InCartItems"));

  // If cart data is not found then return 0
  if (!inCartItems || inCartItems.length === 0) return 0;

  const inCartItemMap = inCartItems.reduce((acc, item) => {
    acc.set(`${item.prdId}-${item.optId}`, item);
    return acc;
    }, new Map());

  // If item is not existed in local storage then return 0
  if (!items.every(({prdId, optId}) => inCartItemMap.has(`${prdId}-${optId}`))) {
    return 0
  }

  // Update isCheckout for each item
  const entity = inCartItems.map(item =>
    inCartItemMap.has(`${item.prdId}-${item.optId}`) ? { ...item, isCheckout: isSelectedAll } : item
  );

  localStorage.setItem("InCartItems", JSON.stringify(entity));

  return items.length;
};

export const deleteItemFromCart = ({prdId, optId}) => {
  const inCartItems = JSON.parse(localStorage.getItem("InCartItems"));

  // If cart data is not found then return 0
  if (!inCartItems || inCartItems.length === 0) return 0;

  const item = inCartItems.find(item => item.prdId === prdId && item.optId === optId);

  // If item is not found then return 0
  if (!item) return 0;

  const entity = inCartItems.filter(item => item.prdId !== prdId || item.optId !== optId);

  localStorage.setItem("InCartItems", JSON.stringify(entity));

  return 1;
};
